import { Controller } from 'react-hook-form';
import { v4 as uuidv4 } from 'uuid';
import {
  ButtonSecondary,
  ButtonSize,
  IconExpand,
  IconLoader,
  Select,
  SelectSize,
  SelectType,
} from '@ui/src';
import RegulatedCompanyRow from './row';
import { AccountsCurrenciesTypes } from './types';
import AccountCurrency from './account-currency';
import AdditionalInfoBlock from '../additional-info-block';
import { CustomerStatus } from '../../../../../hoc/common/types';
import { AccountsCurrenciesFormValues } from '../../../../../hoc/new-application/types';

import cn from './styles.module.css';

const isOdd = (order: number) => {
  const result = order % 2;

  return Boolean(result);
};

const AccountsCurrencies = ({
  control,
  clearErrors,
  errors,
  status,
  typeOfAccounts,
  accountsCurrenciesIsLoading,
  accountsCurrenciesIsFetching,
  accountsCurrenciesValues,
  setAccountsCurrenciesValues,
  currencies,
  onDeleteAccountCurrencies,
  selectedAccountsCurrencyId,
  deleteAccountsCurrenciesInProgress,
  setAccountsFlowsValues,
  accountsFlowsValues,
  isIndividual,
}: AccountsCurrenciesTypes) => (
  <AdditionalInfoBlock title="Purpose for establishing business relationship">
    <>
      {!isIndividual && (
        <RegulatedCompanyRow title="Does the Customer apply KYC procedures?">
          <Controller
            control={control}
            name="accountTypeIds"
            defaultValue={[]}
            render={({ field: { onChange, value, name } }) => (
              <Select
                name={name}
                placeholder="Select an option..."
                list={
                  typeOfAccounts?.map((item) => ({
                    name: item.value,
                    value: item.id,
                  })) || []
                }
                value={value}
                size={SelectSize.SMALL}
                onChange={(e) => {
                  onChange(e);
                  clearErrors(['accountTypeIds']);
                }}
                selectWrapperClassName={
                  status === CustomerStatus.CLOSED ? cn.selectDisabled : ''
                }
                disabled={status === CustomerStatus.CLOSED}
                tabIndex={status === CustomerStatus.CLOSED ? -1 : 0}
                error={errors?.accountTypeIds?.message}
                mode={SelectType.MULTIPLE}
                fullWidth
                borderless
              />
            )}
          />
        </RegulatedCompanyRow>
      )}

      <div className={cn.accountsCurrenciesList}>
        {errors?.questionnairesAccountsCurrencies?.message && (
          <div className={cn.questionnarieError}>
            {errors?.questionnairesAccountsCurrencies?.message}
          </div>
        )}
        {!accountsCurrenciesIsLoading && !accountsCurrenciesIsFetching && (
          <>
            <div className={cn.accountsCurrencyListWrapper}>
              <div className={cn.accountsCurrenciesColumn}>
                {accountsCurrenciesValues
                  ?.filter((item, index) => !isOdd(index))
                  ?.map((item, index) => (
                    <AccountCurrency
                      key={item.id}
                      accountCurrency={item}
                      setAccountsCurrenciesValues={setAccountsCurrenciesValues}
                      currencies={currencies}
                      index={index}
                      status={status}
                      accountsCurrencies={accountsCurrenciesValues}
                      onDeleteAccountCurrencies={onDeleteAccountCurrencies}
                      selectedAccountsCurrencyId={selectedAccountsCurrencyId}
                      deleteAccountsCurrenciesInProgress={
                        deleteAccountsCurrenciesInProgress
                      }
                      setAccountsFlowsValues={setAccountsFlowsValues}
                      accountsFlowsValues={accountsFlowsValues}
                    />
                  ))}
              </div>
              <div className={cn.accountsCurrenciesColumn}>
                {accountsCurrenciesValues
                  ?.filter((item, index) => isOdd(index))
                  ?.map((item, index) => (
                    <AccountCurrency
                      key={item.id}
                      accountCurrency={item}
                      setAccountsCurrenciesValues={setAccountsCurrenciesValues}
                      currencies={currencies}
                      index={index}
                      status={status}
                      accountsCurrencies={accountsCurrenciesValues}
                      onDeleteAccountCurrencies={onDeleteAccountCurrencies}
                      selectedAccountsCurrencyId={selectedAccountsCurrencyId}
                      deleteAccountsCurrenciesInProgress={
                        deleteAccountsCurrenciesInProgress
                      }
                      setAccountsFlowsValues={setAccountsFlowsValues}
                      accountsFlowsValues={accountsFlowsValues}
                    />
                  ))}
              </div>
            </div>

            {currencies &&
              currencies?.filter((item) =>
                accountsCurrenciesValues?.every(
                  (accountCurrency) =>
                    item.value !== accountCurrency.currencyId,
                ),
              )?.length > 0 && (
                <ButtonSecondary
                  text="Add currency"
                  icon={<IconExpand />}
                  className={`button-white ${cn.addAccountCurrencyButton}`}
                  size={ButtonSize.SMALL}
                  onClick={() => {
                    let nextAccountsCurrencies: AccountsCurrenciesFormValues[] =
                      [];

                    if (accountsCurrenciesValues) {
                      nextAccountsCurrencies = (
                        [] as AccountsCurrenciesFormValues[]
                      ).concat(accountsCurrenciesValues);
                    }

                    nextAccountsCurrencies.push({
                      id: `accounts-currency-${uuidv4()}`,
                      currencyId: '',
                      plannedTransactionNature: '',
                      accountOpeningPurpose: '',
                    });

                    setAccountsCurrenciesValues(nextAccountsCurrencies);
                  }}
                />
              )}
          </>
        )}
        {(accountsCurrenciesIsLoading || accountsCurrenciesIsFetching) && (
          <div className={cn.accountsCurrenciesLoader}>
            <IconLoader />
          </div>
        )}
      </div>
    </>
  </AdditionalInfoBlock>
);

export default AccountsCurrencies;
